import Vue from 'vue'
import PrismicVue from 'prismic-vue'
import linkResolver from './prismic/link-resolver'
import htmlSerializer from './prismic/html-serializer'
import App from './App.vue'
import router from './router'
import 'jquery'
import 'bootstrap/dist/js/bootstrap.bundle'
import VueAlertify from 'vue-alertify'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faMapMarkerAlt, faMapPin, faPhone, faEnvelope, faGlobe, faGlobeAmericas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as ModalDialogs from 'vue-modal-dialogs'

library.add([faMapMarkerAlt,faPhone,faEnvelope,faGlobeAmericas])

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  linkResolver,
  htmlSerializer
})
Vue.use(VueAlertify);
Vue.use(ModalDialogs);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


